module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/assign.js
// module id = 208
// module chunks = 35783957827783 52252321336229